import AppliedFilters from '@bd/bdui-appliedfilters';
import styled from '@bd/bdui-styles/emotion';
import { colors } from '../styles';

export default styled(AppliedFilters)`
  margin-top: 20px;
  .AppliedFilters_list {
    margin: 0;
    padding: 0;
    list-style: none;
    width: 100%;
  }
  .AppliedFilters_listItem {
    display: inline-block;
    margin: 0 10px 5px 0;
  }
  .AppliedFilters_listItemButton {
    display: block;
    position: relative;
    padding: 6px 26px 6px 6px;
    font-weight: 800;
    font-size: 12px;
    background-color: #484941;
    color: #FFFFFF;
    border-radius: 3px;
    cursor: pointer;
    &::before, &::after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      right: 8px;
      width: 8px;
      height: 2px;
      background-color: white;
    }
    &::before {
      transform: translateY(-50%) rotateZ(45deg);
    }
    &::after {
      transform: translateY(-50%) rotateZ(-45deg);
    }
    @media (min-width: 768px) {
      font-size: 13px;
    }
  }
  .AppliedFilters_clearButton {
    display: inline-block;
    margin-top: 10px;
    font-size: 12px;
    font-weight: bold;
    color: ${colors.color5};
    border: 1px solid ${colors.color5};
    padding: 5px 10px;
    cursor: pointer;
    @media (min-width: 768px) {
      font-size: 13px;
      margin-top: 15px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/AppliedFilters.js